module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid3.a4af2483.png";